import React from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import R from '../../core-res/R';
import DRNTouchableWrapper from '../Button/TouchableButtonWrapper';
import DRNText from '../../standard/Text/DRNText';
import Checkmark from './Checkmark';
import fieldLocalState from '../../utils/form/fieldLocalState';
import { withTheme } from '../../theme';
import { withSmartKey } from '../../smartkey';
class CheckboxField extends React.Component {
    constructor() {
        super(...arguments);
        this.handleOnChange = () => {
            const { value, onChange } = this.props;
            const nextValue = !value;
            onChange(nextValue);
        };
    }
    render() {
        const { value, label, description, color, disabled, labelStyle, style = {}, theme, accessibilityLabel, testID, } = this.props;
        return (<DRNTouchableWrapper accessible={false} disabled={disabled} onPress={this.handleOnChange}>
        <View style={[styles.container, style]}>
          <Checkmark color={color ? color : theme.tintPrimary} checked={value}/>
          {label ? (<View style={styles.labelContainer}>
              <DRNText style={[styles.label, { color: theme.textPrimary }, value && styles.labelChecked, labelStyle]} accessibilityLabel={accessibilityLabel} testID={testID}>
                {label}
              </DRNText>
              {!!description && (<DRNText style={styles.descriptionText} ink={disabled ? 'muted' : 'secondary'}>
                  {description}
                </DRNText>)}
            </View>) : null}
        </View>
      </DRNTouchableWrapper>);
    }
}
CheckboxField.smartKeyName = ['label', 'description'];
CheckboxField.propTypes = {
    label: PropTypes.string,
    description: PropTypes.string,
    value: PropTypes.bool,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    theme: PropTypes.object,
};
CheckboxField.defaultProps = {
    disabled: false,
    labelStyle: {},
};
export default withSmartKey(fieldLocalState(withTheme(CheckboxField)));
const styles = {
    container: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        padding: R.spacing.m,
    },
    labelContainer: {
        flex: 1,
        flexDirection: 'column',
        marginLeft: R.spacing.s,
    },
    label: Object.assign({}, R.typography.uiBaseline),
    descriptionText: Object.assign({}, R.typography.uiTiny),
};
